import React from 'react';
import { connect } from 'react-redux';
import { ADD_NAME, SET_NAME_VALID } from "../../../actions/types";
import { addElement } from "../../../actions/CreateSiteActions/createSiteActions";
import { validate } from "../../../actions/ValidationActions/serverValidation";
import InfoTooltip from '../../formFields/InfoTooltip';
import RequiredTextField from '../../formFields/RequiredTextField'
import Url from "./Url";
import { updateValidationStatus } from "../../../actions/ValidationActions/validateStep2Acitons.js";
import { illigalCharacterValidation } from "./Validation/IlligalCharactersValidation";
import { debounce } from 'lodash';
import { Spinner, SpinnerSize } from '@fluentui/react';

class Name extends React.Component {

    state = {
        isValidating: false
    }

    // componentDidMount() {
    //     if (this.props.localName) {
    //         this.validateName(this.props.localName);
    //     }
    // }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.localName !== this.props.localName) {
            this.validateName(this.props.localName);
        }
    }


    validateNameOnServer = (name, url) => {
        this.setState({ isValidating: true });

        name = encodeURIComponent(name);
        url = encodeURIComponent(url);
        const isMsTeams = encodeURIComponent(this.props.isMsTeams);

        var validationUrl = `/entryvalidation?name=${name}&isMsTeams=${isMsTeams}`
        if (!this.props.isOnPremise) {
            validationUrl += `&siteUrl=${url}`;
        }

        this.props.validate(validationUrl, SET_NAME_VALID)
            .then(() => { this.setState({ isValidating: false }) });
    }
    
    validateNameDebounce = debounce((value) => {
        let res = illigalCharacterValidation(value, 'Url');
        this.props.updateValidationStatus(SET_NAME_VALID, res);
        if (res.isValid) {
            this.props.updateValidationStatus(SET_NAME_VALID, false);

            // const url = this.props.localName && this.props.location.address
            //     ? this.props.location.address.replace(/\/+$/, '') + `/${this.props.isMsTeams ? 'teams' : 'sites'}/` + value.substr(0, 90)
            //     : null;
            // this.props.addElement(ADD_URL, url);

            this.validateNameOnServer(value, this.props.url);
        }
    }, 500);

    validateName = (value) => {
        this.props.updateValidationStatus(SET_NAME_VALID, {isValid: false});

        this.validateNameDebounce(value);
    }


    onWriteEvent = (e, value) => {
        value = value.replace(/\s*/g, '');

        if (value !== this.props.localName) {
            this.validateName(value);
            this.props.addElement(ADD_NAME, value);
        }
    }

    onBlurEvent = () => {
        this.validateName(this.props.localName);
    }

    render() {
        const validatingSpinner = <div title='Validating...' className='validation-spinner-withLabel'><Spinner size={SpinnerSize.medium} /></div>

        return (
            <div className='wizard-address-div' >
                <div className="item-title">
                    Site address
                    <InfoTooltip content='Please note that the site’s URL cannot be changed later.' />
                </div>
                {this.state.isValidating && validatingSpinner}
                <RequiredTextField 
                    name="Name"
                    onChange={this.onWriteEvent}
                    value={this.props.localName}
                    validationResult={this.props.validationResult}
                    // onBlur={this.onBlurEvent}
                />
                <Url />
            </div>
        );
    }
}

const mapActionToProp =
{
    addElement,
    validate,
    updateValidationStatus
}

const mapStateToProps  = state => ({
    localName : state.newSite.Name,
    validationResult : state.step2Validation.NameValid,
    possibleWarning : state.wizard.nextStepRequested,
    location: state.newSite.Location,
    isMsTeams: state.newSite.isMsTeams,
    isOnPremise: state.newSite.OnPremiseState,
    url: state.newSite.Url
})

export default connect(mapStateToProps,mapActionToProp)(Name);







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/Name.js